(function(){
  "use strict";

  angular.module('irricrops')

  .controller("vinedoSensoresCtrl", [ "$stateParams", '$timeout','$filter','$mdToast','VinedoRes','File', 'CONSTANTES',
  'Config', '$mdDialog', 'global', 'VinedoFac','estadisticas','MultiChart','Upload','urls','temporadaFac','$q','$http',
    function( $stateParams, $timeout, $filter, $mdToast,VinedoRes,File, CONSTANTES,
      Config, $mdDialog, global, VinedoFac, estadisticas, MultiChart, Upload, urls, temporadaFac, $q, $http){


      var vm                = this;
      var tiempoEspera      = 600;
      vm.temporadas         = [];
      vm.temporadaSelected  = null;
      vm.loadingTemporada   = false;
      vm.loadingxls         = false;
      vm.user               = Config.user;
      vm.configVinedo       = Config.vinedo;
      vm.highchartsSensores = null;
      vm.loadingXlsUpload   = 0;



      temporadaFac.getTemporadas().then(function(data){
        vm.temporadas = data.data.data;
        vm.temporadaSelected = temporadaFac.getActiva();
        startMultiChartSensores();
      });


      /**
       *Sensores
       */
      vm.sectorSensorSeleccionado = null;
      vm.estadisticas             = estadisticas.data;
      vm.sectores                 = vm.estadisticas.sectores;
      var titleGraficoSensores    = "Datos de Sensores";


      vm.agregarNuevoSectorSensor = function(res) {
        var nuevoSectorSensor = {
          id:0,
          nombre:"",
          _sensores:[
            {
              id:0,
              altura:30,
              datos: [{
                fecha: 12345,
                cantidad: 12.34
              }]
            }
          ]
        };
        _.forEach(res.data.data, function(dato, index){
          /*
              30_cm:0.292356014251709
              60_cm:0.1562439948320389
              cc:0.21
              fecha:{date: "2016-11-22 20:00:00.000000", timezone_type: 3, timezone: "America/Santiago"}
              pmp:0.074
              umbral:0.142
          * */
        });
      }



      vm.changeTemporada = function() {
        vm.loadingTemporada = true;
        VinedoRes.getSensores({vinedo_id: $stateParams.id,  periodo:vm.temporadaSelected.periodo},
        function(estadisticas){
          vm.estadisticas = estadisticas.data;
          vm.sectores     = vm.estadisticas.sectores;
          startMultiChartSensores();
          vm.loadingTemporada = false;
        });
      };


      var startMultiChartSensores = function() {
        /*
        var last2weeks = false;
        if (vm.estadisticas.sectores.length === 0) {
          return;
        }
        var datosSensores = vm.estadisticas;

        */
        _.forEach(vm.estadisticas.sectores, function (sectorSensor, k) {
          /*
          _.forEach(sectorSensor.sensores, function (sensor, k) {
            if(sensor.datos.length > 500){
              last2weeks = true;
            }
            var aux = [];
            _.forEach(sensor.datos, function (dato, index) { //datos - dia
              if(!last2weeks || (last2weeks && sensor.datos.length - index < 336)){ // 336 = 24*14 --> datos horarios de 2 semanas
                aux.push([dato.fecha * 1000, parseFloat( dato.cantidad ) ]);
              }
            });
            sensor.dataHC = aux;
          });

          sectorSensor.sensores = $filter('orderBy')(sectorSensor.sensores, 'altura');
        */
          sectorSensor.sensores = _.map(sectorSensor.profundidades, function(prof, index){
            return {
              idSensor:prof[1],
              altura:prof[0],
              dataHC: _.without(_.map(sectorSensor.datos, function(dato, indexDato){
                if(indexDato == 0) return null;
                return [dato[0] * 1000, dato[index+1]];
              }), null)
            }
          })
        });

        vm.selectSectorSensor(vm.estadisticas.sectores[0]);
      };

      vm.selectSectorSensor = function( sectorSensor) {
        vm.sectorSensorSeleccionado = sectorSensor;

        vm.hSensores = new MultiChart(titleGraficoSensores + " " + (sectorSensor ? sectorSensor.nombre : '') +" - ("+ vm.temporadaSelected.periodo +")");
        vm.hSensores.showTimeTooltip();
        vm.hSensores.deletePositioner();
        vm.highchartsSensores = null;

        angular.forEach(sectorSensor.sensores, function(sensor, key) {
          vm.hSensores.agregarSerie({
//            color: Config.colors.sensor1.background,
            name         : 'Sensor '+ parseInt(sensor.altura) +"cm",
            yAxis        : 3,
            radius       : 3,
            type         : 'spline',
            suffix       : ' %',
            markerSymbol : 'triangle',
            data         : angular.copy(sensor.dataHC),
            visibleAxis: true
          });
        });
        $timeout(function(){
              vm.highchartsSensores = vm.hSensores.getConfig();
            }, 10);
      };









      vm.leerXlsSensores = function(file, invalidFiles){
        var reader = new FileReader();

        reader.onload = async function (e) {
          /* read workbook */
          var bstr     = e.target.result;
          var workbook = XLSX.read(bstr, {type:'binary'});
          var result   = {};

          workbook.SheetNames.forEach(function(sheetName) {
            var roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {header:1});
            //if(roa.length) result[sheetName] = roa;
            result = roa;
          });



          var dataSensores = _.compact(_.flatMap(result, function(data){
            if(typeof data[0] == "string" || data[0] == undefined){
              return null;
            }

            var fecha = moment.unix( (data[0] * 86400) - 2209075200).subtract("day", 1).utc()

            if(fecha.seconds() == 59){
              fecha.add("seconds", 1);
            }

            var fechaString = fecha.format("YYYY-MM-DD HH:mm");
            //var fechaStringRecalculada = fecha.format("YYYY-MM-DD HH:mm");
            //if(data[1] < 60){
              //fechaStringRecalculada = fecha.add("minutes", 60 - data[1]).format("YYYY-MM-DD HH:mm");
            //}

            return [
              {
              //30
              cantidad  : data[1] * 100,
              fecha     : fechaString,
              //fechaRecalculada : fechaStringRecalculada,
              sensor_id : _.find(vm.sectorSensorSeleccionado.profundidades,function(prof){return prof[0]==30})[1]
            },
              {
              //60
              cantidad  : data[2] * 100,
              fecha     : fechaString,
              //fechaRecalculada : fechaStringRecalculada,
              sensor_id : _.find(vm.sectorSensorSeleccionado.profundidades,function(prof){return prof[0]==60})[1]
            },
            /*
              {
              //100
              cantidad  : data[3], //*100,
              fecha     : fechaString,
              //fechaRecalculada : fechaStringRecalculada,
              sensor_id : _.find(vm.sectorSensorSeleccionado.profundidades,function(prof){return prof[0]==100})[1]
            }
            */
          ];

          }));




          var paramsDataRiego = _.compact(_.flatMap(result, function(data){
            if(typeof data[0] == "string" || data[0] == undefined || data[4] == 0){
              return null;
            }

            return _.filter(_.flatMap(vm.sectorSensorSeleccionado.sectores_riego, function(sector){


              var fecha = moment.unix( (data[0] * 86400) - 2209075200).subtract("day", 1).utc();

              if(fecha.seconds() == 59){
                fecha.add("seconds", 1);
              }

              var fechaString            = fecha.format("YYYY-MM-DD");
              var fechaStringRecalculada = fecha.format("YYYY-MM-DD HH:mm");
              var fechaRecalculada = fecha;

              if(data[4] < 60){
                fechaRecalculada       = fecha.add("minutes", 60 - data[4])
                fechaStringRecalculada = fecha.add("minutes", 60 - data[4])
                .format("YYYY-MM-DD HH:mm");
              }


              if(data[4] > 0){
                return {
                  cod: data[0],
                  moment: fecha,
                  fecha: fechaString, //moment.unix( (data[0] * 86400) - 2209075200).subtract("day", 1).utc().format("YYYY-MM-DD"),
                  //fechaOriginal    : fecha.format("YYYY-MM-DD"), //moment.unix( (data[0] * 86400) - 2209075200).subtract("day", 1).utc().format("YYYY-MM-DD"),
                  //fechaRecalculada : fechaStringRecalculada,
                  hora_inicio_r: fechaRecalculada.format("HH:mm"),
                  horas_reales: data[4],
                  sector_riego_id: sector.id
                };
              }
              return null;

            }));
          }));



          paramsDataRiego = _.reduce(paramsDataRiego, function(acc, item, index){
            var itemF = _.find(acc, {fecha: item.fecha});
            if(itemF){
              itemF.horas_reales += item.horas_reales;
            }else{
              acc.push(item);
            }
            return acc;
          }, []);



          paramsDataRiego = _.map(paramsDataRiego, function(p){
            p.horas_reales = p.horas_reales / 60;
            return p;
          })




          //agrupa array en grupos de 100 elementos por "pagina"
          var paramsData = _.map(
            _.reduce(dataSensores, function(arr, data, index){
              //divide array en partes de 100 elementos
              arr.push(_.drop(dataSensores,100*index).slice(0,100));
              return arr;
            }, []), function(datos){
              //page
              return datos;
            });

          paramsData = _.reject(paramsData, _.isEmpty);


          function saveData(params){
            if(params.length == 0){
              return
            }
            return $http.post(urls.BASE+"/sensor/dato", {datos:params});
          }

          function saveDataRiego(params){
            if(params.length == 0){
              return
            }
            return $http.post(urls.BASE+"/sector-riego/datos-riego-dia", params);
          }

          vm.loadingXlsUpload = 0;


          for (var i = 0; i < paramsData.length; i++) {
            await saveData(paramsData[i]);
            vm.loadingXlsUpload = (i / (paramsData.length + paramsDataRiego.length)) * 100;
            console.log(i + "  >>"+ (i / (paramsData.length + paramsDataRiego.length)) + " << ");
          }

          for (var i = 0; i < paramsDataRiego.length; i++) {
            await saveDataRiego(paramsDataRiego[i]);
            vm.loadingXlsUpload = (( paramsData.length + i ) / (paramsData.length + paramsDataRiego.length)) * 100;
          }

          vm.loadingXlsUpload = 100;

        };

        reader.readAsBinaryString(file);
      }

      vm.subirXlsSensores = function (file, invalidFiles) {
        if (file !== null) {
          vm.loadingxls = true;
        }
        var fuPromise = File.upload(file, invalidFiles, 'vinedo/sensores', 'archivo');
        if (fuPromise !== null) {
          fuPromise.then(function(res) {
            vm.loadingxls = false;
            vm.fileProgress = null;
            vm.changeTemporada();
          }, function(res_error) {
            vm.loadingxls = false;
            console.error(res_error);
          }, function(evt) {
            // Math.min is to fix IE which reports 200% sometimes
            vm.fileProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });
        }
      };

      vm.subirXlsAADiscontinuo = function (file, invalidFiles) {
        if (file !== null) {
          vm.loadingxls = true;
        }
        var fuPromise = File.upload(file, invalidFiles, 'vinedo/sensores-aaa', 'archivo');
        if (fuPromise !== null) {
          fuPromise.then(function(res) {
            vm.loadingxls = false;
            vm.fileProgress = null;
            vm.changeTemporada();
            $mdToast.show(
                $mdToast.simple()
                    .textContent(res.data.msj)
                    .position(CONSTANTES.TOAST_POSITION)
            );
          }, function(res_error) {
            vm.loadingxls = false;
            console.error(res_error);
          }, function(evt) {
            // Math.min is to fix IE which reports 200% sometimes
            vm.fileProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });
        }
      };

      vm.showDialogAAContinuo = function(evt) {
        $mdDialog.show({
              templateUrl         : 'components/vinedo/sensores/AAContinuo.dialog.html',
              parent              : angular.element(document.body),
              targetEvent         : evt,
              clickOutsideToClose : true,
              controllerAs        : "d",
              bindToController    : true,
              locals              : {
                sectoresSensor: vm.sectores,
                subirXlsAAContinuo: vm.subirXlsAAContinuo,
                agregarNuevoSectorSensor: vm.agregarNuevoSectorSensor
              },
              controller : ["$scope", function($scope) {
                var vm     = this;
                vm.loading = false;

                function createFilterFor(query) {
                  var lowercaseQuery = angular.lowercase(query);
                  return function filterFn(sectorsensor) {
                    return (angular.lowercase(sectorsensor.nombre).indexOf(lowercaseQuery) >= 0);
                  };
                }

                vm.querySearch = function(query) {
                  var r = query !=="" ? vm.sectoresSensor.filter( createFilterFor(query) ) : vm.sectoresSensor
                  if(query !== ""){
                    r.push({
                      nombre: query,
                      new: true
                    });
                  }
                  return r;
                }

                vm.hide = function() {
                  $mdDialog.hide();
                };
                vm.cancel = function() {
                  $mdDialog.cancel();
                };
                vm.answer = function(answer) {
                  $mdDialog.hide(answer);
                };
                vm.subirXlsSensores = function(file, query) {
                  vm.loading = true;
                  vm.subirXlsAAContinuo(file, {
                    nombre_sector: query,
                    vinedo_id: $stateParams.id
                  }).then(function(res) {
                    vm.loading = false;
                    vm.answer("ready");
                    //vm.agregarNuevoSectorSensor(res); //TODO refrescar con tadtos de respuesta
                    //vm.selectSectorSensor();
                    $mdToast.show(
                        $mdToast.simple()
                            //.textContent(res.data.msj)
                            .textContent("Subido XLS de manera exitosa")
                            .position(CONSTANTES.TOAST_POSITION)
                    );
                  }, function(err) {
                    vm.loading = false;
                  });
                }
              }],
            })
            .then(function(answer) {

            }, function() {

            });
      }

      vm.subirXlsAAContinuo = function (file, data) {
        if (file !== null) {
          vm.loadingxls = true;
        }
        var fileProgress = 0;
        var fuPromise = File.upload(file, null, 'vinedo/excel-sensores-acevedo', 'archivo', data, false);
        if (fuPromise !== null) {
          fuPromise.then(function(res) {
            vm.loadingxls = false;
            vm.fileProgress = null;
            vm.changeTemporada();
          }, function(res_error) {
            vm.loadingxls = false;
            console.error(res_error);
          }, function(evt) {
            // Math.min is to fix IE which reports 200% sometimes
            fileProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            console.log(fileProgress);
          });
          return fuPromise;
        }
      };







      vm.subirXlsIrrimax = function (file, data) {
        if (file !== null) {
          vm.loadingxls= true;
        }
        var fileProgress = 0;
        var fuPromise = File.upload(file, null, 'vinedo/sensores-irrimax', 'archivo', data);
        if (fuPromise !== null) {
          fuPromise.then(function(res) {
            vm.loadingxls = false;
            vm.fileProgress = null;
            vm.changeTemporada();
          }, function(res_error) {
            vm.loadingxls = false;
            console.error(res_error);
          }, function(evt) {
            // Math.min is to fix IE which reports 200% sometimes
            fileProgress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            console.log(fileProgress);
          });
          return fuPromise;
        }
      };




      vm.showDialogIrrimax = function(evt) {
        $mdDialog.show({
          templateUrl         : 'components/vinedo/sensores/irrimax.dialog.html',
          parent              : angular.element(document.body),
          targetEvent         : evt,
          clickOutsideToClose : true,
          controllerAs        : "d",
          bindToController    : true,
          locals              : {
            sectoresSensor: vm.sectores,
            subirXlsIrrimax: vm.subirXlsIrrimax,
          },
          controller : ["$scope", function($scope) {
            var vm = this;
            vm.loading = false;

            function createFilterFor(query) {
              var lowercaseQuery = angular.lowercase(query);
              return function filterFn(sectorsensor) {
                return (angular.lowercase(sectorsensor.nombre).indexOf(lowercaseQuery) >= 0);
              };
            }

            vm.querySearch = function(query) {
              var r = query ? vm.sectoresSensor.filter( createFilterFor(query) ) : vm.sectoresSensor
              r.push({
                nombre: query,
                new: true
              });
              return r;
            }

            vm.hide = function() {
              $mdDialog.hide();
            };
            vm.cancel = function() {
              $mdDialog.cancel();
            };
            vm.answer = function(answer) {
              $mdDialog.hide(answer);
            };
            vm.subirXlsSensores = function(file, query) {
              vm.loading = true;
              vm.subirXlsIrrimax(file, {
                nombre_sector: query,
                vinedo_id: $stateParams.id
              }).then(function(res) {
                vm.loading = false;
                vm.answer("ready");
                $mdToast.show(
                  $mdToast.simple()
                  .textContent(res.data.msj)
                  .position(CONSTANTES.TOAST_POSITION)
                );
              }, function(err) {
                vm.loading = false;
              });
            }
          }],
        })
        .then(function(answer) {
          vm.changeTemporada();
        }, function() {

        });
      }


  }]);

})();
